// 스크롤 이벤트를 발생 시키고 싶은 영역에 감싸주고 각 영역을 아래처럼 선언 해준다.
// <div data-controller="components--scroll-observer">
//  <section data-components--scroll-observer-target="section"
//            data-section-name="free_shares"></section>
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "section" ];
  static classes = [ "" ]
  static values = {
    source: String,
    os: String,
  };

  initialize() {
    this.observer = null;
    this.fireBaseEventName = "scroll_webapp"; // 스크롤 이벤트는 이걸로 fix -> https://karrot.atlassian.net/wiki/spaces/DATA/pages/999719008/Firebase+Analytics
  }

  logEvent(name, params) {
    if (this.osValue === "ios") {
      window.webkit.messageHandlers.logEventHandler.postMessage({ name: name, params: params });
    } else if (this.osValue === "android") {
      AndroidFunction.logEvent(name, JSON.stringify(params))
    } else {
      if (process.env.NODE_ENV !== "production") {
        console.log(name, params)
      }
    }
  }

  entryHandler = (entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const { sectionName } = entry.target.dataset;
        this.logEvent(this.fireBaseEventName, {
          source: this.sourceValue,
          section: sectionName,
        })
        this.observer.unobserve(entry.target);
      }
    })
  }

  connect() {
    let options = {
      root: null, // observe 하는 전체 기준 영역, null 로 두변 브라우저 뷰 포트
      rootMargin: '0px',
      threshold: 0 // section 의 얼만큼의 지분이 노출되면 이벤트를 일으킬지 여부. 화면이 작은 디바이스의 경우 section 이 화면보다 크면 이벤트 생략 됨. 0으로 두는게 좋음
    }

    this.observer = new IntersectionObserver(this.entryHandler, options);
    this.sectionTargets.forEach((target) => {
      this.observer.observe(target);
    })
  }

  disconnect() {
    this.observer.destroy();
  }
}